export default __webpack_public_path__ + "static/bullseye-99b4493a4b7f360d46b1d5ea5cbd3ec1.png";